export default __webpack_public_path__ + "locales/vi/VersionHistory.json?hash=1032e7ad06d29539fe02f0a48bdfee27";